import type { Config, ConfigService } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, InstanceManagementState } from '../../../models'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { INSTANCE_MANAGEMENT_CONSTS } from '../instance-management.consts'

export class ListServiceConfigsAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<InstanceManagementState, any>,
    filter: { instance: string } | { service: string },
  ): Promise<Config[]> {
    const configService = CONTAINER.get<ConfigService>(TYPES.ConfigService)
    const configs = (await configService.list({ filter })).results
    commit(INSTANCE_MANAGEMENT_CONSTS.mutations.setServiceConfigs, configs)
    return configs
  }
}
